import React, { useState, useEffect, useRef } from "react";

const TestimonialSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const testimonials = [
    {
      name: "Billy Josiah",
      review: "Amazing quality and fast delivery! The sofa exceeded my expectations.",
      rating: 5,
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=150&q=80"
    },
    {
      name: "Steve Casscallen",
      review: "Perfect furniture for our new home. Great customer service too!",
      rating: 5,
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=150&q=80"
    },
    {
      name: "Technova",
      review: "Love the modern design and comfort. Highly recommend Brand Decor!",
      rating: 5,
      image: "https://images.unsplash.com/photo-1494790108755-2616b612b5f8?auto=format&fit=crop&w=150&q=80"
    }
  ];

  const moreTestimonials = [
    {
      name: "Jane M.",
      review: "The dining set is so elegant, and delivery was right on time!",
      rating: 4,
      image: "https://images.unsplash.com/photo-1544723795-3fb6469f5b39?auto=format&fit=crop&w=150&q=80"
    },
    {
      name: "Michael O.",
      review: "Superb quality, worth every penny. My living room feels brand new!",
      rating: 5,
      image: "https://images.unsplash.com/photo-1541532713592-79a0317b6b77?auto=format&fit=crop&w=150&q=80"
    },
    {
      name: "Lucy K.",
      review: "Excellent craftsmanship and very comfortable. I’ll shop again!",
      rating: 5,
      image: "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?auto=format&fit=crop&w=150&q=80"
    }
  ];

  const displayedTestimonials = showMore
    ? [...testimonials, ...moreTestimonials]
    : testimonials;

  return (
    <div ref={sectionRef} className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2
            className={`text-4xl font-bold text-gray-800 mb-4 transform transition-all duration-800 ease-out ${
              isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
            }`}
          >
            What Our Customers Say
          </h2>
          <p
            className={`text-gray-600 text-lg transform transition-all duration-800 ease-out delay-100 ${
              isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
            }`}
          >
            Hear from our satisfied customers about their experience
          </p>
        </div>

        {/* Testimonials grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {displayedTestimonials.map((testimonial, index) => (
            <div
              key={index}
              className={`bg-gray-50 rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-all duration-500 transform ${
                isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"
              }`}
              style={{ transitionDelay: `${index * 100 + 200}ms` }}
            >
              <div className="mb-6">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full mx-auto mb-4 object-cover"
                />
                <div className="flex justify-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <svg
                      key={i}
                      className="w-5 h-5 text-yellow-400 fill-current"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
              </div>
              <p className="text-gray-700 mb-4 italic">
                "{testimonial.review}"
              </p>
              <h4 className="font-semibold text-gray-800">
                {testimonial.name}
              </h4>
            </div>
          ))}
        </div>

        {/* Button */}
        <div
          className={`text-center mt-12 transform transition-all duration-800 ease-out delay-500 ${
            isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
          }`}
        >
          <button
            onClick={() => setShowMore(!showMore)}
            className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg font-semibold hover:scale-105 transition-all duration-300"
          >
            {showMore ? "Show Less" : "Read More Reviews"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSection;
